import CTABand from '../components/CTABand.jsx';
import SEO from '../components/SEO.jsx';
import useReveal from '../hooks/useReveal.js';
import { ArrowL } from '../components/Icons.jsx';
import { localBusinessSchema } from '../data/schemas.js';

export default function Cases() {
  useReveal();
  return (
    <main>
      <SEO
        title="מקרים מהשטח | FocusMode"
        description="מקרים שבהם FocusMode נכנסה לעסק, אתר, מערכת או פרויקט שהיו צריכים סדר, אפיון והובלה ברורה."
        path="/cases"
        schema={[localBusinessSchema]}
      />

      <section className="cases-hero wrap reveal">
        <div className="sec-eyebrow">מקרים מהשטח</div>
        <h1 className="h1">
          לא סיפורי הצלחה נוצצים.<br />
          מקרים של <span className="hl-block tilt-l">עבודה אמיתית</span>.
        </h1>
        <p className="lede">
          FocusMode נכנסת בדרך כלל לפני שהכול נראה מסודר. לפעמים יש אתר שלא מייצג את העסק.
          לפעמים בקשה קטנה מסתירה פרויקט גדול. כאן מתחילים לראות את התבנית.
        </p>
      </section>

      <section className="sec cases-list">
        <div className="wrap">
          <article className="case-card reveal">
            <div className="case-tag">אתר עם AI · פחות מחודש</div>
            <h2>FlyMoments</h2>
            <p>
              חברה שמוכרת חוויות וכנסים לארגונים, אבל לא הייתה לה נוכחות דיגיטלית שמסבירה את הרמה שלה.<br />
              העבודה כללה אפיון, קופי, עיצוב, פיתוח ועלייה לאוויר.<br />
              המטרה: שמבקר יבין מהר מי החברה, למה לסמוך עליהם, ואיך להמשיך.<br />
              ביקשו חוויה ויזואלית, הייטקית שמכניסה לאווירת חוויה שלמה.
            </p>
            <a className="btn btn-dark" href="https://flymoments.com" target="_blank" rel="noopener noreferrer">
              לראות את האתר <ArrowL size={14} />
            </a>
          </article>

          <div className="case-trust reveal">
            <p>12 שנה בדיגיטל. עבודה עם סוכנויות, מותגים ועמותות בישראל.</p>
          </div>
        </div>
      </section>

      <CTABand source="cta-band-cases" />
    </main>
  );
}
